import {inject, Injectable}                                   from '@angular/core';
import {MatDialog, MatDialogRef}                              from '@angular/material/dialog';
import {CrudRecordIntf, CrudRecordType}                       from '@djsharkk/logr-types';
import {lastValueFrom}                                        from 'rxjs';
import {DialogConfirmComponent, DialogConfirmDataIntf}        from '../comps/dialogs/dialog-confirm/dialog-confirm.component';
import {DialogEditRecordDataIntf, DialogEditWrapperComponent} from '../comps/dialogs/dialog-edit/dialog-edit-wrapper/dialog-edit-wrapper.component';
import {DialogWrapperContentIntf}                             from '../comps/dialogs/dialog-wrapper/dialog-wrapper.component';

export type DialogMessageType =
	| 'delete'
	| 'discard'

export type DialogMessageDict = {
	[key in DialogMessageType]: DialogConfirmDataIntf
}

@Injectable({
				providedIn: 'root'
			})
export class UiDialogsService {

	dialog = inject(MatDialog)

	confirmMessages: DialogMessageDict = {
		'delete' : {
			title  : 'Confirm Deletion',
			message: 'Are you sure you want to delete this item?'
		},
		'discard': {
			title  : 'Discard Changes',
			message: 'Are you sure you want to discard the changes to this item?'
		}
	}

	async dialogConfirm(messageKey: DialogMessageType): Promise<boolean>;
	async dialogConfirm(data: DialogConfirmDataIntf): Promise<boolean>;
	async dialogConfirm(messageKeyOrData: DialogMessageType | DialogConfirmDataIntf): Promise<boolean | undefined> {
		const dialogRef: MatDialogRef<DialogConfirmComponent, boolean> = this.dialog.open(DialogConfirmComponent, {
			data: typeof messageKeyOrData === 'object' ? messageKeyOrData : this.confirmMessages[messageKeyOrData]
		});
		return await lastValueFrom(dialogRef.afterClosed());
	}

	async dialogEdit<T extends CrudRecordIntf>(type: CrudRecordType, d: T, content: DialogWrapperContentIntf = {
		title: 'Edit',
		descr: []
	}) {
		const data: DialogEditRecordDataIntf = {
			content,
			type,
			data: d
		}
		const dialogRef: MatDialogRef<DialogEditWrapperComponent, boolean> = this.dialog.open(
			DialogEditWrapperComponent,
			{
				data,
				backdropClass: 'custom-dialog-backdrop'
			}
		);

		return await lastValueFrom(dialogRef.afterClosed());
	}


}
